import {
  SET_MISSING_TIME_SUCCESS,
  GET_ORPAK_LATEST,
  GET_ORPAK_LATEST_ERROR,
  GET_ORPAK_LATEST_SUCCESS,
  GET_FUEL_SOURCE_COMPARISON,
  GET_FUEL_SOURCE_COMPARISON_ERROR,
  GET_FUEL_SOURCE_COMPARISON_SUCCESS,
  GET_SERVER_STATUS_SUCCESS
} from './Countdown.actions'
import { SERVICE_HEALTH } from '../../store/models/status'

const countdownState = {
  missingTime: null,
  orpakLoading: false,
  orpakError: false,
  orpakData: {
    data: []
  },
  levelsMean: 0,
  weeklyTank: 0,
  dayTurn: 0,
  nightTurn: 0,
  fuelSourceComparison: {
    data: [],
    loading: false,
    error: false
  },
  serverStatus: {
    health: SERVICE_HEALTH.OPERATIONAL,
    sources: null
  }
}

/**
 * The countdown' reducer.
 */
const countdownReducer = (state = countdownState, { payload, type }) => {
  switch (type) {
    case SET_MISSING_TIME_SUCCESS: {
      return { ...state, missingTime: payload.missingTime }
    }
    case GET_ORPAK_LATEST: {
      return { ...state, orpakLoading: true, orpakError: false }
    }
    case GET_ORPAK_LATEST_ERROR: {
      return { ...state, orpakLoading: false, orpakError: true }
    }
    case GET_ORPAK_LATEST_SUCCESS: {
      return {
        ...state,
        orpakLoading: false,
        orpakError: false,
        orpakData: payload.orpakData,
        levelsMean: payload.levelsMean,
        weeklyTank: payload.weeklyTank,
        dayTurn: payload.dayTurn,
        nightTurn: payload.nightTurn
      }
    }
    case GET_FUEL_SOURCE_COMPARISON: {
      return { ...state, fuelSourceComparison: { ...state.fuelSourceComparison, loading: true, error: false } }
    }
    case GET_FUEL_SOURCE_COMPARISON_ERROR: {
      return { ...state, fuelSourceComparison: { ...state.fuelSourceComparison, loading: false, error: true } }
    }
    case GET_FUEL_SOURCE_COMPARISON_SUCCESS: {
      return { ...state, fuelSourceComparison: { data: payload.data, loading: false, error: false } }
    }
    case GET_SERVER_STATUS_SUCCESS: {
      return { ...state, serverStatus: { health: payload.health, sources: payload.sources } }
    }
    default: {
      return state
    }
  }
}

export default countdownReducer
